import { MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { RootState } from '../../stores/globalStore';
import { Language } from '../../models/Language';
import './Lang.scss';
import { setConnectedUser } from '../../stores/authenticationStore';
import { AuthHeader } from '../../utils/helpers/auth-headers';

function LangSelector() {
  const { i18n } = useTranslation();
  const [lang, setLang] = useState<string>(i18n.language);

  const connectedUser = useSelector((state: RootState) => state.authentication.connectedUser);
  const dispatch = useDispatch();

  const updateLangUser = (updateLang: string) => {  
    const updatePrefs = { ...connectedUser.prefs };
    updatePrefs.lang = updateLang;
    const modifyPrefs = {
      prefs: updatePrefs
    };
    axios.post(`${window._env_.REACT_APP_API_URI}/user/prefs`, modifyPrefs, { headers: AuthHeader() ? { Authorization: `Bearer ${AuthHeader()}` } : {} })
      .then((response) => {
        dispatch(setConnectedUser({ connectedUser: response.data.data }));
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    if (connectedUser.prefs?.lang) {
      setLang(connectedUser.prefs?.lang);
      i18n.changeLanguage(connectedUser.prefs?.lang);
    }
  }, [connectedUser]);

  const changeLanguage = (event: SelectChangeEvent<string>) => {
    const language = event.target.value;

    switch (language) {
    case Language.EN:
      setLang(Language.EN);
      i18n.changeLanguage(Language.EN);
      updateLangUser(language);
      break;
    case Language.FR:
    default:
      setLang(Language.FR);
      i18n.changeLanguage(Language.FR);
      updateLangUser(language);
      break;
    }
  };

  return (
    <div>
      <div className="language-selector">
        <Select
          id="langue-simple-select"
          className="language-select"
          value={lang}
          name="language"
          onChange={changeLanguage}
        >
          <MenuItem value={Language.FR}>FR</MenuItem>
          <MenuItem value={Language.EN}>EN</MenuItem>
        </Select>
      </div>
    </div>
  );
}

export default LangSelector;
